/**
 * Cart drawer discount code module.
 * - Persists a typed/applied code in localStorage so it survives cart AJAX merges and drawer reopens.
 * - Appends the code to checkout links as a `discount` query param (Shopify applies it automatically at checkout).
 * - Best-effort clipboard auto-fill when the drawer opens, gated behind a discount-code-shaped regex so it never
 *   overwrites the field with unrelated copied text.
 */
(function () {
  var STORAGE_KEY = 'winsons:cart-discount-code';
  var CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9-_]{2,19}$/;

  function isLikelyDiscountCode(value) {
    return !!value && CODE_PATTERN.test(value.trim());
  }

  function getSavedCode() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function saveCode(code) {
    try {
      if (code) {
        window.localStorage.setItem(STORAGE_KEY, code);
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      /* localStorage unavailable (private mode, etc.) - fail silently */
    }
  }

  function updateCheckoutLinks(code) {
    document.querySelectorAll('[data-checkout-link]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.pathname.indexOf('/checkout') === -1) return;
        if (code) {
          url.searchParams.set('discount', code);
        } else {
          url.searchParams.delete('discount');
        }
        link.href = url.toString();
      } catch (error) {
        /* ignore malformed URLs */
      }
    });
  }

  function populateInputs(code) {
    document.querySelectorAll('[data-discount-input]').forEach(function (input) {
      if (!input.value && code) input.value = code;
    });
  }

  function showFeedback(input, type) {
    var container = input.closest('[data-discount-code]');
    var feedback = container && container.querySelector('[data-discount-feedback]');
    if (!feedback) return;
    var message = type === 'invalid' ? feedback.dataset.invalidText : feedback.dataset.appliedText;
    feedback.textContent = message || '';
    feedback.hidden = !message;
  }

  function applyCode(input) {
    var code = (input.value || '').trim().toUpperCase();
    if (!code) {
      showFeedback(input, 'invalid');
      return;
    }
    input.value = code;
    saveCode(code);
    updateCheckoutLinks(code);
    populateInputs(code);
    showFeedback(input, 'applied');
  }

  function tryAutofillFromClipboard() {
    if (!navigator.clipboard || !navigator.clipboard.readText) return;

    var emptyInputs = Array.prototype.slice
      .call(document.querySelectorAll('[data-discount-input]'))
      .filter(function (input) {
        return !input.value;
      });
    if (!emptyInputs.length) return;

    navigator.clipboard
      .readText()
      .then(function (text) {
        var trimmed = (text || '').trim();
        if (!isLikelyDiscountCode(trimmed)) return;
        var code = trimmed.toUpperCase();
        emptyInputs.forEach(function (input) {
          if (!input.value) input.value = code;
        });
      })
      .catch(function () {
        /* clipboard read denied or unsupported - ignore */
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var savedCode = getSavedCode();
    if (savedCode) {
      populateInputs(savedCode);
      updateCheckoutLinks(savedCode);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-discount-apply]');
    if (!button) return;
    var container = button.closest('[data-discount-code]');
    var input = container && container.querySelector('[data-discount-input]');
    if (!input) return;
    applyCode(input);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-discount-input]');
    if (!input) return;
    event.preventDefault();
    applyCode(input);
  });

  // Dispatched (bubbles: true) by side-drawer.js right before the cart drawer opens.
  document.addEventListener('on:cart-drawer:before-open', tryAutofillFromClipboard);

  // Dispatched (bubbles: true) by main.js after an AJAX cart update replaces the drawer's markup.
  document.addEventListener('on:cart:after-merge', function () {
    var savedCode = getSavedCode();
    if (savedCode) {
      populateInputs(savedCode);
      updateCheckoutLinks(savedCode);
    }
  });
})();
